const getter = {
  isLocationTracking(state) {
    return !!state.locationInterval;
  }
  
}
export default getter



// WEBPACK FOOTER //
// ./src/store/getter.js